import React from 'react';
import PropTypes from 'prop-types';
import '../countdown-timer.style.scss';
import classNames from 'classnames';

const TimerBlock = ({
  timeStringAndMessaging,
  shouldUseMessagingString,
  shouldIncludeSvg
}) => {

  const timerClasses = classNames('countdown-timer__wrapper', 'countdown-timer__wrapper--block');

  return (
    <div className={timerClasses}>
      {timeStringAndMessaging.messagingString && shouldUseMessagingString && (
        <div className="countdown-timer__clock-block">
          <span>
            {shouldIncludeSvg && (
              <img src="https://assets.homedepot-static.com/images/v1/clock-black.svg" alt="" />
            )}
            {timeStringAndMessaging.messagingString}
          </span>
        </div>
      )}
      {timeStringAndMessaging.timeString && (
        <div className="countdown-timer__time-block">
          {timeStringAndMessaging.timeString}
        </div>
      )}
    </div>
  );
};

TimerBlock.propTypes = {
  shouldUseMessagingString: PropTypes.bool,
  shouldIncludeSvg: PropTypes.bool,
  timeStringAndMessaging: PropTypes.shape({
    messagingString: PropTypes.string,
    timeString: PropTypes.string
  })
};

TimerBlock.defaultProps = {
  shouldUseMessagingString: false,
  shouldIncludeSvg: false,
  timeStringAndMessaging: {
    messagingString: '',
    timeString: ''
  }
};

export default TimerBlock;
